// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAddRequest, TAddModel, IMappers, TAddResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IAddFilesResponse } from '../../entities/Models/AddFilesResponse';

export function createAddModel(parameters: IAddRequest): TAddModel {
  const formData = new FormData();

  if (parameters.file) {
    formData.append('file', parameters.file);
  }

  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'files',
    pathApi: '/v1/add/',
    response: {
      200: {
        contentType: 'json',
      },
    },
    request: {
      parameters: formData,
    },
  };
}

export interface IAddOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IAddRequest;
}

export async function fetchAdd<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddOptions<TResponse200>): Promise<FetchResponse<TAddResponse> | TResponse200> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddModel(parameters),
    config,
  )) as FetchResponse<TAddResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFilesResponse, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TAddResponse>;
}
